"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
exports.reducer = reducer;
var _types = require("../actions/types");
const initialState = exports.initialState = {};
function reducer(state, action) {
  switch (action.type) {
    case _types.GET_ADDRESS:
    case _types.GET_ADDRESS_FAILED:
    case _types.GET_ADDRESSES:
    case _types.GET_ADDRESSES_FAILED:
    case _types.CREATE_ADDRESS:
    case _types.CREATE_ADDRESS_FAILED:
    case _types.UPDATE_ADDRESS:
    case _types.UPDATE_ADDRESS_FAILED:
    case _types.DELETE_ADDRESS:
    case _types.DELETE_ADDRESS_FAILED:
    case _types.GET_FAVOURITE_ADDRESS:
    case _types.GET_FAVOURITE_ADDRESS_FAILED:
    case _types.GET_ADDRESS_SPECIFICITIES_FAILED:
      return {
        ...state,
        ...action.payload
      };
    case _types.GET_ADDRESS_SPECIFICITIES:
      return {
        ...state,
        addressFieldSpecificities: action.payload
      };
    default:
      return state;
  }
}